module.exports = __webpack_public_path__ + "images/4277c37687540742b6c6514079bd60e1.svg";